import { createAction, createReducer } from '@reduxjs/toolkit';

import {
  UPDATE_PROVISIONAL_OFFER_REQUEST,
  UPDATE_PROVISIONAL_OFFER_SUCCESS,
  UPDATE_PROVISIONAL_OFFER_FAILURE,
} from '../actions/updateProvisionalOfferActions';

export const initialState = {
  item: {},
  loading: false,
  error: null,
};

const updateProvisionalOfferRequest = state => ({
  ...state,
  loading: true,
  error: null,
});

const updateProvisionalOfferSuccess = (state, action) => ({
  ...state,
  item: action.payload,
  loading: false,
});

const updateProvisionalOfferFailure = (state, action) => ({
  ...state,
  item: {},
  loading: false,
  error: action.payload,
});

const provisionalOffer = createReducer(initialState, builder => {
  builder
    .addCase(createAction(UPDATE_PROVISIONAL_OFFER_REQUEST), updateProvisionalOfferRequest)
    .addCase(createAction(UPDATE_PROVISIONAL_OFFER_SUCCESS), updateProvisionalOfferSuccess)
    .addCase(createAction(UPDATE_PROVISIONAL_OFFER_FAILURE), updateProvisionalOfferFailure);
});

export default provisionalOffer;
